// src/pages/inventory/ContinentalInventory.jsx
import React from 'react';
import InventoryDashboard from '../InventoryDashboard';

const ContinentalInventory = () => {
  return <InventoryDashboard locationKey="continental" />;
};

export default ContinentalInventory;